import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, FormField } from 'components/ui/form';
import { InputGs } from 'components/ui/Forms';
import { Button } from 'components/ui/ButtonGs';
import { useMutation, useQueryClient } from 'react-query';
import { useErrorHandler } from 'exceptions/ErrorHandler';
import { formSchema } from '../../formSchema';
import { useAiUser } from 'hooks/api/settings/useAiUser';
import { useHistory } from 'react-router-dom';
import { customMask } from 'lib/customMask';
import { toast } from 'sonner';

export const CreateForm: React.FC = () => {
  const navigate = useHistory();
  const { errorHandler } = useErrorHandler();
  const { createAiUser } = useAiUser();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  const queryClient = useQueryClient();
  const mutation = useMutation(createAiUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('aiUsers');
      navigate.push('/settings/ai-users');
      toast.success('Usuário de IA criado com sucesso!');
    },
    onError: (error) => {
      errorHandler(error);
    },
  });

  const onSubmit = (data: z.infer<typeof formSchema>) => {
    mutation.mutate(data);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <FormField
            name="name"
            control={form.control}
            render={({ field }) => <InputGs {...field} label="Nome" />}
          />
          <FormField
            name="phone_number"
            control={form.control}
            render={({ field }) => (
              <InputGs
                {...field}
                label="Telefone"
                onChange={(e) =>
                  field.onChange(customMask(e.target.value, '9999999999999'))
                }
              />
            )}
          />
        </div>
        <div className="flex justify-end w-full gap-4">
          <Button.Root
            variant="secondary"
            size="sm"
            type="button"
            onClick={() => navigate.push('/settings/ai-users')}
          >
            Cancelar
          </Button.Root>
          <Button.Root
            variant="primary"
            size="sm"
            type="submit"
            disabled={mutation.isLoading}
          >
            Salvar
          </Button.Root>
        </div>
      </form>
    </Form>
  );
};
